import { Component } from 'react'
import {
  NetworkGraphController,
  NetworkGraphButtonsControlsFrame,
  NetworkGraphButton,
} from './styles'

class NetworkSelector extends Component {
  render() {
    return (
      <NetworkGraphController>
        <NetworkGraphButtonsControlsFrame>
          <NetworkGraphButton selected={true}>Wireless</NetworkGraphButton>
          <NetworkGraphButton>Wired</NetworkGraphButton>
          <NetworkGraphButton>WAN</NetworkGraphButton>
        </NetworkGraphButtonsControlsFrame>
      </NetworkGraphController>
    )
  }
}

export default NetworkSelector
